$(function () {

	if ($('#popup-form-modal').length > 0) {
		$("<a href='#popup-form-modal'></a>")
			.fancybox()
			.trigger("click");
	}

});